// extracted by mini-css-extract-plugin
module.exports = {"main":"Manifests-module__main--2BPUl","more":"Manifests-module__more--1X238"};